import {useState} from "react";

export const useForm = (initialValues) => {
    const [values, setValues] = useState(initialValues);

    const changeHandler = (e) => {
        setValues(state => ({...state, [e.target.name]: e.target.value}));
    };


    const onSubmitInitialValues = () => {
      setValues(initialValues);
    };

    const onSubmitEditValues = (editValues) => {
        setValues(editValues);
    }

    return {
        values,
        changeHandler,
        onSubmitInitialValues,
        onSubmitEditValues
    };
};